
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("lP6S3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $fe33b0cfe0297d00$var$_jquery = $fe33b0cfe0297d00$var$_interopRequireDefault((parcelRequire("4kMWr")));

var $fe33b0cfe0297d00$var$_swiper = $fe33b0cfe0297d00$var$_interopRequireDefault((parcelRequire("htp1E")));

var $bTZx8 = parcelRequire("bTZx8");
function $fe33b0cfe0297d00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $fe33b0cfe0297d00$var$init = module.exports.init = function init() {
    var homeThumbnails = new $fe33b0cfe0297d00$var$_swiper["default"](".swiper-home-thumbnails", {
        slidesPerView: 1,
        centeredSlides: true,
        centeredSlidesBounds: true,
        watchSlidesProgress: true,
        breakpoints: {
            768: {
                slidesPerView: 3
            }
        }
    });
    var homeSlider = new $fe33b0cfe0297d00$var$_swiper["default"](".swiper-home-slider", {
        modules: [
            $bTZx8.Navigation,
            $bTZx8.Thumbs,
            $bTZx8.A11y,
            $bTZx8.Keyboard
        ],
        initialSlide: 1,
        keyboard: {
            enabled: true
        },
        navigation: {
            nextEl: ".swiper-home-slider-next",
            prevEl: ".swiper-home-slider-prev"
        },
        thumbs: {
            swiper: homeThumbnails
        },
        a11y: {
            enabled: true
        },
        on: {
            beforeInit: function beforeInit() {
                (0, $fe33b0cfe0297d00$var$_jquery["default"])(".swiper-home-thumbnails .swiper-slide").each(function() {
                    var $this = (0, $fe33b0cfe0297d00$var$_jquery["default"])(this);
                    var param = $this.find("a").attr("href");
                    $this.find("a").attr("data-href", param);
                });
                (0, $fe33b0cfe0297d00$var$_jquery["default"])(".ctype-ce_home_slider .blur-img").fadeOut();
            },
            afterInit: function afterInit() {
                (0, $fe33b0cfe0297d00$var$_jquery["default"])(".ctype-ce_home_slider").addClass("slider-init");
                homeThumbnails.slideTo(1, 0);
            },
            transitionStart: function transitionStart(swiper) {
                homeThumbnails.slideTo(swiper.activeIndex, 200);
            },
            transitionEnd: function transitionEnd(swiper) {
                (0, $fe33b0cfe0297d00$var$_jquery["default"])(".swiper-home-thumbnails .swiper-slide a").attr("href", "javascript:void(0);");
                var href = (0, $fe33b0cfe0297d00$var$_jquery["default"])(".swiper-home-thumbnails .swiper-slide-thumb-active a").attr("data-href");
                (0, $fe33b0cfe0297d00$var$_jquery["default"])(".swiper-home-thumbnails .swiper-slide-thumb-active a").attr("href", href);
            }
        }
    });
    homeThumbnails.on("transitionEnd", function(swiper) {
        if (swiper.activeIndex !== homeSlider.activeIndex) homeSlider.slideTo(swiper.activeIndex, 200);
    });
};

});

parcelRegister("7bv9Y", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $53b1bb303d082687$export$581ff339ea0ba762; });

var $cgqFP = parcelRequire("cgqFP");
function $53b1bb303d082687$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cgqFP._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("cgqFP", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $8edbab78a07e92a4$export$1e71eb4bef00f6b0; });
function $8edbab78a07e92a4$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("evINV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a906b7200f9116bb$export$4fa2f4023c9cbda5; });
function $a906b7200f9116bb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a906b7200f9116bb$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $a906b7200f9116bb$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=home.module.42da09f7.js.map
